import { createCommand } from '@commander-js/extra-typings';
import type { CommandServices } from '@wix/cli-command-contract';
import { envPullCommand } from './env-pull.js';
import { envSetCommand } from './env-set.js';
import { envRemoveCommand } from './env-remove.js';

export const envCommand = (services: CommandServices, cliVersion: string) => {
  return createCommand('env')
    .description('Work with environment variables')
    .addCommand(envPullCommand(services, cliVersion))
    .addCommand(envSetCommand(services, cliVersion))
    .addCommand(envRemoveCommand(services, cliVersion));
};
